"use strict";

exports.__esModule = true;
exports.CollectionSearcher = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Core = require("../../Core");
var _excluded = ["reload"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var makeLoader = function makeLoader(_ref) {
  var collection = _ref.collection;
  return function (params) {
    var term = params.term,
      filterPredicate = params.filterPredicate,
      parseSearchItem = params.parseSearchItem;

    // search the cached items
    var cached = collection.optimisticSearch(term, filterPredicate, parseSearchItem);
    if (cached !== undefined) {
      return cached;
    }
    // search with a fetch
    return collection.search(term, filterPredicate);
  };
};
var CollectionSearcher = exports.CollectionSearcher = /*#__PURE__*/function (_Component) {
  function CollectionSearcher() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      load: makeLoader(_this.props)
    };
    return _this;
  }
  _inheritsLoose(CollectionSearcher, _Component);
  var _proto = CollectionSearcher.prototype;
  _proto.render = function render() {
    var _this2 = this;
    var _this$props = this.props,
      children = _this$props.children,
      term = _this$props.term,
      params = _this$props.params,
      filterPredicate = _this$props.filterPredicate,
      parseSearchItem = _this$props.parseSearchItem;
    var load = this.state.load;
    return /*#__PURE__*/_react["default"].createElement(_Core.AsyncLoader, {
      load: load,
      params: Object.assign({
        term: term,
        filterPredicate: filterPredicate,
        parseSearchItem: parseSearchItem
      }, params)
    }, function (_ref2) {
      var _reload = _ref2.reload,
        extra = _objectWithoutPropertiesLoose(_ref2, _excluded);
      return children(Object.assign({}, extra, {
        reload: function reload() {
          return _this2.props.collection.clearCache(_reload);
        }
      }));
    });
  };
  return CollectionSearcher;
}(_react.Component);